module.exports = __webpack_public_path__ + "img/79200.d099ba19.jpg";